<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">운영보고서</span>
            <span class="txt">기존 데이터에서 중요한 정보를 한눈에 확인할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/stats/month')">월간 보고서</button>
            <button class="on">기간별 보고서</button>
            <button @click="onClickRouter('/madmin/stats/year')">연간 보고서</button>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap ui-month-calendar">
                    <vue-monthly-picker v-model="selectedBeforeMonth" dateFormat="YYYY년 MM월"></vue-monthly-picker>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <vue-monthly-picker v-model="selectedAfterMonth" dateFormat="YYYY년 MM월"></vue-monthly-picker>
                </div>
                <!--                <select-form :select-data='["선택","1개월","2개월","3개월"]' :select-value="[1,1,2,3]" @update:set="val => monthDate = val"></select-form>-->
                <div class="right">
                    <button class="com-btn excel" @click="execlDownload">엑셀 다운로드</button>
                </div>
            </div>
        </div>

        <div class="com-table-top">
            <p class="sub-title bold">상담</p>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>전화</th>
                        <th>방문</th>
                        <th>기타</th>
                        <th>총 상담 수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in consult" :key="`consult_${index}`">
                        <td>
                            <strong>{{ convertMonth(c.month) }}</strong>
                        </td>
                        <td>{{ c.tel }}</td>
                        <td>{{ c.visit }}</td>
                        <td>{{ c.etc }}</td>
                        <td>
                            <strong>{{ c.total }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top profit">
            <p class="sub-title bold">매출</p>
            <span class="title">
                전체 수익 현황
                <div class="com-tooltip right">
                    도움말
                    <button class="icon"></button>
                    <div class="detail big">
                        <div class="division-wrap">
                            <div class="info-area">
                                <span class="tit">소진금액</span>
                                <p class="txt">1회당 단가 x 사용횟수</p>
                                <span class="tit">잔여금액</span>
                                <p class="txt">
                                    해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                    <br />
                                    소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                    <br />
                                    <br />

                                    예시)
                                    <br />
                                    결제금액 : 10회 500,000원
                                    <br />
                                    회당 단가 50,000원
                                    <br />
                                    수업 3회 사용완료인 경우
                                    <br />
                                    소진매출 : 150,000원
                                    <br />
                                    잔여금액 : 350,000원
                                </p>
                                <p class="txt red">
                                    ※ 소진금액, 잔여금액은 이용권의 횟수가 기간제/무제한으로 설정된 경우 정확한 금액을
                                    환산할 수 없습니다. 해당 이용권이 포함되어있는 경우 정확하지 않을 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>이용권 수입</th>
                        <th>일반수입</th>
                        <th>환불</th>
                        <th class="gray">매출합계</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, index) in price" :key="`price_${index}`">
                        <td>
                            <strong>{{ convertMonth(p.month) }}</strong>
                        </td>
                        <td>{{ p.ticketIncome | numberFormatFilter }}</td>
                        <td>{{ p.income | numberFormatFilter }}</td>
                        <td>{{ p.refund | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ p.saleTotal | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <!-- <tr>
                    <td><strong>2월</strong></td>
                    <td>35,000,000</td>
                    <td>500,000</td>
                    <td>0</td>
                    <td><strong>40,000,000</strong></td>
                </tr> -->
                </tbody>
            </table>
            <table class="com-table w1080">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>고정지출</th>
                        <th>변동지출</th>
                        <th>급여</th>
                        <th class="gray">지출합계</th>
                        <th class="blue">영업이익</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, index) in price" :key="`p2_${index}`">
                        <td>
                            <strong>{{ convertMonth(p.month) }}</strong>
                        </td>
                        <td>{{ p.fix | numberFormatFilter }}</td>
                        <td>{{ p.vari | numberFormatFilter }}</td>
                        <td>{{ p.salary | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ p.expenseTotal | numberFormatFilter }}</strong>
                        </td>
                        <td>
                            <strong>{{ p.sale | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <!-- <tr>
                    <td><strong>2월</strong></td>
                    <td>35,000,000</td>
                    <td>500,000</td>
                    <td>0</td>
                    <td><strong>40,000,000</strong></td>
                    <td><strong>1,700,000</strong></td>
                </tr> -->
                </tbody>
            </table>
            <table class="com-table w540">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th class="blue"></th>
                        <th class="blue">이용권 소진금액</th>
                        <th class="blue">이용권 잔여금액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, index) in price" :key="`p3_${index}`">
                        <td>
                            <strong>{{ convertMonth(p.month) }}</strong>
                        </td>
                        <td>{{ p.remain | numberFormatFilter }}</td>
                        <td>{{ p.used | numberFormatFilter }}</td>
                    </tr>
                    <!-- <tr>
                    <td><strong>2월</strong></td>
                    <td>35,000,000</td>
                    <td>500,000</td>
                </tr> -->
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">신규 / 재등록 현황</span>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>신규건수</th>
                        <th>신규매출</th>
                        <th>재등록건수</th>
                        <th>재등록매출</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in contractType" :key="`ct_${index}`">
                        <td>
                            <strong>{{ convertMonth(c.month) }}</strong>
                        </td>
                        <td>{{ c.new }}</td>
                        <td>{{ c.newSale | numberFormatFilter }}</td>
                        <td>{{ c.re }}</td>
                        <td>
                            <strong>{{ c.reSale | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <!-- <tr>
                    <td><strong>2월</strong></td>
                    <td>3</td>
                    <td>200,000</td>
                    <td>9</td>
                    <td><strong>15,000,000</strong></td>
                </tr> -->
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">
                결제수단별 상품매출
                <small>(이용권 수입 + 일반 수업)</small>
            </span>
            <table class="com-table layout-fixed">
                <thead>
                    <tr>
                        <th></th>
                        <th>핏페이</th>
                        <th>카드</th>
                        <th>현금</th>
                        <th>계좌</th>
                        <th>기타</th>
                        <th class="gray">합계</th>
                        <th>마일리지 사용</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, index) in payType" :key="`paytype_${index}`">
                        <td>
                            <strong>{{ convertMonth(p.month) }}</strong>
                        </td>
                        <td>{{ p.fitpay | numberFormatFilter }}</td>
                        <td>{{ p.card | numberFormatFilter }}</td>
                        <td>{{ p.cash | numberFormatFilter }}</td>
                        <td>{{ p.bank | numberFormatFilter }}</td>
                        <td>{{ p.etc | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ p.total | numberFormatFilter }}</strong>
                        </td>
                        <td>{{ p.mileage | numberFormatFilter }}</td>
                    </tr>
                    <!-- <tr>
                    <td><strong>2월</strong></td>
                    <td>10,000,000</td>
                    <td>200,000</td>
                    <td>1,000,000</td>
                    <td>0</td>
                    <td><strong>3,000,000</strong></td>
                    <td>100,000</td>
                </tr> -->
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">이용권 구분별 매출현황</span>
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>개인</th>
                        <th>듀엣</th>
                        <th>오티</th>
                        <th>그룹</th>
                        <th>쿠폰</th>
                        <th>회원권</th>
                        <th>운동복</th>
                        <!-- <th>패키지</th> -->
                        <th class="gray">합계</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(t, index) in ticketType" :key="`tt_${index}`">
                        <td>
                            <strong>{{ convertMonth(t.month) }}</strong>
                        </td>
                        <td>{{ t.person | numberFormatFilter }}</td>
                        <td>{{ t.duet | numberFormatFilter }}</td>
                        <td>{{ t.ot | numberFormatFilter }}</td>
                        <td>{{ t.group | numberFormatFilter }}</td>
                        <td>{{ t.coupon | numberFormatFilter }}</td>
                        <td>{{ t.ticket | numberFormatFilter }}</td>
                        <td>{{ t.sport | numberFormatFilter }}</td>
                        <!-- <td>{{t.pakage | numberFormatFilter}}</td> -->
                        <td>
                            <strong>{{ t.total | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <!-- <tr>
                    <td><strong>2월</strong></td>
                    <td>10,000,000</td>
                    <td>200,000</td>
                    <td>1,000,000</td>
                    <td>3,000,000</td>
                    <td>0</td>
                    <td>100,000</td>
                    <td>0</td>
                    <td><strong>20,000,000</strong></td>
                </tr> -->
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">환불현황</span>
            <table class="com-table w480">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>총 건수</th>
                        <th>금액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(r, index) in refundStatus" :key="`rs_${index}`">
                        <td>{{ convertMonth(r.cc_date) }}</td>
                        <td>{{ r.cc_cnt }}</td>
                        <td>{{ r.cc_total_price | numberFormatFilter }}</td>
                    </tr>
                    <!-- <tr>
                    <td>2월</td>
                    <td>5</td>
                    <td>1,500,000</td>
                </tr>
                <tr>
                    <td>3월</td>
                    <td>5</td>
                    <td>1,500,000</td>
                </tr> -->
                </tbody>
            </table>
            <p class="sub-title bold">직원</p>
            <div class="check-line">
                <div class="com-check">
                    <input
                        id="select-check-1-1"
                        v-model="sign"
                        name="select-check-1"
                        type="checkbox"
                        value="I"
                        @change="onStaffBill"
                    />
                    <label for="select-check-1-1">근무중인 직원</label>
                </div>
                <div class="com-check">
                    <input
                        id="select-check-1-2"
                        v-model="resign"
                        name="select-check-1"
                        type="checkbox"
                        value="O"
                        @change="onStaffBill"
                    />
                    <label for="select-check-1-2">퇴사한 직원</label>
                </div>
                <div class="com-tooltip right">
                    도움말
                    <button class="icon"></button>
                    <div class="detail big gap">
                        <div class="division-wrap">
                            <div class="info-area">
                                <span class="tit">소진금액</span>
                                <p class="txt">1회당 단가 x 사용횟수</p>
                                <span class="tit">잔여금액</span>
                                <p class="txt">
                                    해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                    <br />
                                    소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                </p>
                                <span class="tit">유효건수</span>
                                <p class="txt">해당직원이 ‘담당강사’로 선택된 이용권 중 유효한 이용권 건수</p>
                                <span class="tit">종료건수</span>
                                <p class="txt">
                                    해당직원이 ‘담당강사’로 선택된 이용권 중 해당 기간에
                                    <br />
                                    종료된 이용권 건수 (종료 후 재등록 여부와는 상관 없음)
                                </p>
                                <p class="txt red">
                                    ※ 소진금액, 잔여금액은 이용권의 횟수가 기간제/무제한으로 설정된 경우 정확한 금액을
                                    환산할 수 없습니다. 해당 이용권이 포함되어있는 경우 정확하지 않을 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 180px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>직원명</th>
                        <th>월</th>
                        <th>총 매출</th>
                        <th>신규매출</th>
                        <th>재등록 매출</th>
                        <th>소진금액</th>
                        <th>잔여금액</th>
                        <th>유효건수</th>
                        <th>종료건수</th>
                        <th>신규건수</th>
                        <th>재등록 건수</th>
                        <th>총 수업 수</th>
                        <th>차인 지급액</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(monthList, staffIndex) in staff">
                        <tr v-for="(m, mIdx) in monthList" :key="`m_${staffIndex}_${mIdx}`">
                            <td v-if="mIdx === 0" :rowspan="monthList.length > 1 && mIdx === 0 ? monthList.length : ''">
                                {{ m.csbb_center_staff_nm }}
                            </td>
                            <td>{{ formatMonth(m.csbb_bill_year_month) }}</td>
                            <td>{{ m.csbb_total_sale_price | numberFormatFilter }}</td>
                            <td>{{ m.csbb_sale_new_price | numberFormatFilter }}</td>
                            <td>{{ m.csbb_sale_renew_price | numberFormatFilter }}</td>
                            <td>{{ m.csbb_tick_use_price | numberFormatFilter }}</td>
                            <td>{{ m.csbb_real_sale_price | numberFormatFilter }}</td>
                            <td>{{ m.csbb_sale_new_cnt }}</td>
                            <td>{{ m.csbb_less_finish_cnt }}</td>
                            <td>{{ m.csbb_sale_new_cnt }}</td>
                            <td>{{ m.csbb_sale_renew_cnt }}</td>
                            <td>{{ m.csbb_less_total_cnt }}</td>
                            <td>{{ m.csbb_real_sale_price }}</td>
                        </tr>
                    </template>
                    <!-- <tr>
                    <td>김윤경</td>
                    <td>2월</td>
                    <td>5,000,000</td>
                    <td>4,000,000</td>
                    <td>6,000,000</td>
                    <td>30,000,000</td>
                    <td>30</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>3</td>
                    <td>110</td>
                    <td>30,000,000</td>
                </tr>
                <tr>
                    <td>김윤경</td>
                    <td>3월</td>
                    <td>5,000,000</td>
                    <td>4,000,000</td>
                    <td>6,000,000</td>
                    <td>30,000,000</td>
                    <td>30</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>3</td>
                    <td>440</td>
                    <td>30,000,000</td>
                </tr> -->
                    <tr class="total border">
                        <td>합계</td>
                        <td colspan="2">{{ totalSalePrice | numberFormatFilter }}</td>
                        <td>{{ saleNewPrice | numberFormatFilter }}</td>
                        <td>{{ saleRenewPrice | numberFormatFilter }}</td>
                        <td>{{ tickUsePrice | numberFormatFilter }}</td>
                        <td>{{ realSalePrice | numberFormatFilter }}</td>
                        <td>{{ lessValidCnt }}</td>
                        <td>{{ lessFinishCnt }}</td>
                        <td>{{ saleNewCnt }}</td>
                        <td>{{ saleRenewCnt }}</td>
                        <td>{{ lessTotalCnt }}</td>
                        <td>{{ totalRealSalePrice | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import XLSX from 'xlsx';
import { numberFormat } from '@/assets/js/excelCommon.js';

export default {
    name: 'StatsPeriod',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        selectedMonth() {
            return this.monthlyPicker.format('YYYY-MM');
        },
        //직원 총매출
        totalSalePrice: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log('총매출', s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_total_sale_price);
                }
            }
            return result;
        },
        //신규매출
        saleNewPrice: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_sale_new_price);
                }
            }
            return result;
        },
        //재등록매출
        saleRenewPrice: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_sale_renew_price);
                }
            }
            return result;
        },
        //소진금액
        tickUsePrice: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_tick_use_price);
                }
            }
            return result;
        },
        //잔여금액
        realSalePrice: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_real_sale_price);
                }
            }
            return result;
        },
        //유효건수
        lessValidCnt: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_less_valid_cnt);
                }
            }
            return result;
        },
        //종료건수
        lessFinishCnt: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_less_finish_cnt);
                }
            }
            return result;
        },
        //신규건수
        saleNewCnt: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_sale_new_cnt);
                }
            }
            return result;
        },
        //재등록건수
        saleRenewCnt: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_sale_renew_cnt);
                }
            }
            return result;
        },
        //총 수업 수
        lessTotalCnt: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_less_total_cnt);
                }
            }
            return result;
        },
        //차인 지금액
        totalRealSalePrice: function () {
            let result = 0;
            for (let s of this.staff) {
                console.log(s);
                for (let d in s) {
                    result += parseInt(s[d].csbb_real_sale_price);
                }
            }
            return result;
        },
    },
    data() {
        return {
            centerId: '',
            selectedBeforeMonth: moment().subtract(2, 'months').format('YYYY-MM'), //년월 설정
            selectedAfterMonth: moment().format('YYYY-MM'), //년월 설정
            startDate: moment().subtract(2, 'months').format('YYYYMM'),
            endDate: moment().format('YYYYMM'),
            monthDate: '',
            consult: [],
            price: [],
            contractType: [],
            payType: [],
            ticketType: [],
            staff: [],
            billStatus: 'T', // 직원통계 조회를 위한 기본값 radio값에 의해 변경
            sign: true,
            resign: true,
            refundStatus: [],
        };
    },
    watch: {
        // monthDate:function(val){
        //     console.log(val);
        //     this.showCount = val;
        //     this.selectedBeforeMonth = moment().subtract(val-1, 'months');
        //     this.startDate = moment(this.selectedBeforeMonth).format('YYYYMM'),
        //     this.endDate = moment(this.selectedAfterMonth).format('YYYYMM'),
        //     this.init();
        // },
        selectedBeforeMonth() {
            //console.log(moment(moment(this.selectedBeforeMonth).format('YYYYMM')).diff(moment(this.endDate),'months'))
            if (moment(moment(this.selectedBeforeMonth).format('YYYYMM')).diff(moment(this.endDate), 'months') < -2) {
                alert('날짜를 다시 선택해주십시오. 시작검색기간은 최대 3개월까지 가능합니다.');
                //this.selectedBeforeMonth = moment(this.selectedBeforeMonth).add(1,'month').format('YYYYMM')
                this.selectedBeforeMonth = moment().format('YYYY-MM');
            } else {
                if (
                    moment(moment(this.selectedBeforeMonth).format('YYYYMM')).diff(moment(this.endDate), 'months') > 0
                ) {
                    alert('날짜를 다시 선택해주십시오. 시작검색기간은 종료일보다 늦을 수 없습니다.');
                    this.selectedBeforeMonth = moment().format('YYYY-MM'); //년월 설정
                    return;
                }
                this.startDate = moment(this.selectedBeforeMonth).format('YYYYMM');
                this.selectedBeforeMonth = moment(this.selectedBeforeMonth).format('YYYYMM');
                this.init();
            }
        },
        selectedAfterMonth() {
            //console.log(moment(moment(this.selectedAfterMonth).format('YYYYMM')).diff(moment(this.startDate),'months'))
            if (moment(moment(this.selectedAfterMonth).format('YYYYMM')).diff(moment(this.startDate), 'months') > 2) {
                alert('날짜를 다시 선택해주십시오. 종료검색기간은 최대 3개월까지 가능합니다.');
                //this.selectedAfterMonth = moment(this.selectedAfterMonth).subtract(1,'month').format('YYYYMM')
                this.selectedAfterMonth = moment().format('YYYY-MM'); //년월 설정
            } else {
                if (
                    moment(moment(this.selectedAfterMonth).format('YYYYMM')).diff(moment(this.startDate), 'months') < 0
                ) {
                    alert('날짜를 다시 선택해주십시오. 종료검색기간은 시작일보다 빠를 수 없습니다.');
                    this.selectedAfterMonth = moment().format('YYYY-MM'); //년월 설정
                    return;
                }
                this.endDate = moment(this.selectedAfterMonth).format('YYYYMM');
                this.selectedAfterMonth = moment(this.selectedAfterMonth).format('YYYYMM');
                this.init();
            }
        },
        period() {},
    },
    mounted() {
        this.centerId = this.cId; //센터id
        this.init();
    },
    methods: {
        //초기화
        async init() {
            try {
                await this.onTermConsult();
                await this.onTermConsultType();
                await this.onTermPayType();
                await this.onTermTicketType();
                await this.onTermStaffBill();
                await this.onTermSaleStat();
                await this.onReturnStat();
                await this.onStaffBill(); //현재 response 데이터 값 없음
            } catch (error) {
                console.log(error);
                console.log('초기화 오류입니다.');
            }
        },
        //상담조회
        async onTermConsult() {
            try {
                const { data } = await this.getTermConsult();
                console.log('상담조회 데이터', data);

                /*
                [
                    {"month":, "tel" "visit", "etc"}
                ]

                cc_consult_cnt: "2"
                cc_consult_path: "V"
                cc_stats_month: "2021-01"
                */

                let monthObj = {};

                for (let d of data) {
                    const key = d.cc_stats_month;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            tel: 0,
                            visit: 0,
                            etc: 0,
                            total: 0,
                        };
                    }

                    switch (d.cc_consult_path) {
                        case 'T':
                            monthObj[key].tel += parseInt(d.cc_consult_cnt);
                            break;
                        case 'V':
                            monthObj[key].visit += parseInt(d.cc_consult_cnt);
                            break;
                        case 'E':
                            monthObj[key].etc += parseInt(d.cc_consult_cnt);
                            break;
                    }

                    monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> monthobj', monthObj);

                let keys = Object.keys(monthObj).sort();

                this.consult = [];
                for (let k of keys) {
                    this.consult.push(monthObj[k]);
                }

                console.log('====> consult', this.consult);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //상담조회 api
        getTermConsult() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/consult`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            });
        },
        //신규 재등록조회
        async onTermConsultType() {
            try {
                const { data } = await this.getTermConsultType();
                console.log('신규 재등록조회', data);

                let monthObj = {};

                for (let d of data) {
                    const key = d.cc_buy_dt;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            new: 0,
                            newSale: 0,
                            re: 0,
                            reSale: 0,
                        };
                    }

                    switch (d.cc_contract_type_cd) {
                        case 'N':
                            monthObj[key].new += parseInt(d.cc_contract_type_cd_cnt);
                            monthObj[key].newSale += parseInt(d.cc_total_buy_price);
                            break;
                        case 'R':
                            monthObj[key].re += parseInt(d.cc_contract_type_cd_cnt);
                            monthObj[key].reSale += parseInt(d.cc_total_buy_price);
                            break;
                    }
                }

                console.log('====> 신규재등록', monthObj);

                let keys = Object.keys(monthObj).sort();

                this.contractType = [];
                for (let k of keys) {
                    this.contractType.push(monthObj[k]);
                }

                console.log('====> consult', this.consult);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //신규 재등록조회 api
        getTermConsultType() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/contract-type`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            });
        },
        //결제수단 조회
        async onTermPayType() {
            try {
                const { data } = await this.getTermPayType();
                console.log('결제수단 조회', data);

                let monthObj = {};

                for (let d of data) {
                    const key = d.ccb_buy_dt;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            card: 0,
                            cash: 0,
                            bank: 0,
                            etc: 0,
                            fitpay: 0,
                            mileage: 0,
                            total: 0,
                        };
                    }

                    switch (d.ccb_pay_type_cd) {
                        case 'B':
                            monthObj[key].bank += parseInt(d.ccb_bill_price);
                            monthObj[key].total += parseInt(d.ccb_bill_price);
                            break;
                        case 'C':
                            monthObj[key].card += parseInt(d.ccb_bill_price);
                            monthObj[key].total += parseInt(d.ccb_bill_price);
                            break;
                        case 'L':
                            monthObj[key].cash += parseInt(d.ccb_bill_price);
                            monthObj[key].total += parseInt(d.ccb_bill_price);
                            break;
                        case 'E':
                            monthObj[key].etc += parseInt(d.ccb_bill_price);
                            monthObj[key].total += parseInt(d.ccb_bill_price);
                            break;
                        case 'T':
                        case 'U':
                            monthObj[key].fitpay += parseInt(d.ccb_bill_price);
                            monthObj[key].total += parseInt(d.ccb_bill_price);
                            break;
                        case 'M':
                            monthObj[key].mileage += parseInt(d.ccb_bill_price);
                            break;
                    }
                }

                console.log('====> 신규재등록', monthObj);

                let keys = Object.keys(monthObj).sort();

                this.payType = [];
                for (let k of keys) {
                    this.payType.push(monthObj[k]);
                }

                console.log('====> consult', this.consult);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //결제수단 조회 api
        getTermPayType() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/pay-type`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            });
        },
        //이용권 구분별 매출현황 조회
        async onTermTicketType() {
            try {
                const { data } = await this.getTermTicketType();
                console.log('이용권조회', data);

                let monthObj = {};

                for (let d of data) {
                    const key = d.ccp_buy_dt;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            person: 0,
                            duet: 0,
                            ot: 0,
                            group: 0,
                            coupon: 0,
                            ticket: 0,
                            pakage: 0,
                            total: 0,
                        };
                    }

                    switch (d.ccp_ticket_type_cd) {
                        case 'P':
                            monthObj[key].person += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'D':
                            monthObj[key].duet += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'O':
                            monthObj[key].ot += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'G':
                            monthObj[key].group += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'C':
                            monthObj[key].coupon += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'T':
                            monthObj[key].ticket += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'PK':
                            monthObj[key].pakage += parseInt(d.ccp_total_bill_price);
                            monthObj[key].total += parseInt(d.ccp_total_bill_price);
                            break;
                    }
                }

                console.log('====> 신규재등록', monthObj);

                let keys = Object.keys(monthObj).sort();

                this.ticketType = [];
                for (let k of keys) {
                    this.ticketType.push(monthObj[k]);
                }

                console.log('====> consult', this.consult);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //이용권 조회 api
        getTermTicketType() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/ticket-type`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            });
        },
        //직원급여
        async onTermStaffBill() {
            try {
                const { data } = await this.getTermStaffBill();
                console.log('직원급여', data);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //직원급여 조회 api
        getTermStaffBill() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/staff-bill`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            });
        },
        //매출 조회
        async onTermSaleStat() {
            try {
                const { data } = await this.getTermSaleStat();
                console.log('매출조회', data);

                let monthObj = {};

                for (let d of data) {
                    const key = d.css_sale_year_month;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            ticketIncome: parseInt(d.css_tick_price),
                            income: parseInt(d.css_prod_price),
                            refund: parseInt(d.css_ret_price),
                            fix: parseInt(d.css_fix_exp_price),
                            vari: parseInt(d.css_var_exp_price),
                            //급여
                            salary: parseInt(d.css_pay_price),
                            //영업이익
                            sale: parseInt(d.css_oper_profit_cnt),
                            //이용권소진금액
                            used: parseInt(d.css_tick_exh_price),
                            //이용권잔여금액
                            remain: parseInt(d.css_tick_remain_price),

                            //매출합계
                            saleTotal:
                                parseInt(d.css_prod_price) + parseInt(d.css_pay_price) - parseInt(d.css_ret_price),
                            //지출합계
                            expenseTotal:
                                parseInt(d.css_fix_exp_price) +
                                parseInt(d.css_var_exp_price) +
                                parseInt(d.css_total_exp_price),
                        };
                    }

                    //    monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> price', monthObj);

                let keys = Object.keys(monthObj).sort();

                this.price = [];
                for (let k of keys) {
                    this.price.push(monthObj[k]);
                }

                console.log('====> price', this.price);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //매출조회 api
        getTermSaleStat() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/sale-stats`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            });
        },
        //직원통계 조회
        async onStaffBill() {
            try {
                this.billStatus = this.signStatus();
                const { data } = await this.getStaffBill();
                console.log('직원통계 데이터', data);
                this.staff = data;

                /*
                    {
                            name:[
                                {month:'1월',sale:'',....}
                                {month:'2월',sale:'',....}
                                ]
                            name1:[
                                {}
                                {}
                            ],
                            name2:[
                                1:{},
                                2:{}
                            ],
                    }


                    [
                        [
                            {name:"명섭", month: "2020-12", ... },
                            {name:"명섭", month: "2020-12", ... },
                            {name:"명섭", month: "2020-12", ... }
                        ],
                        [],
                        [],
                    ]
                */
                // csbb_bill_year_month: "202101"
                // csbb_center_staff_id: 39
                // csbb_center_staff_nm: "강타"

                let obj = {};

                for (let d of data) {
                    const key = d.csbb_center_staff_id;
                    if (obj[key] === undefined) {
                        obj[key] = [];
                    }
                    obj[key].push(d);
                }
                console.log('aaa', obj);

                let keys = Object.keys(obj); //이름배열
                console.log(keys);

                this.staff = [];
                for (let k of keys) {
                    this.staff.push(obj[k]);
                }
                console.log('list', this.staff);
            } catch (error) {
                console.log(error);
                console.log('직원통계 오류입니다.');
            }
        },
        //직원통계 조회 api
        getStaffBill() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/term/staff-bill`, {
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    status: this.billStatus, //전체 T 입사 I 퇴사O
                },
            });
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        //월변환
        convertMonth(month) {
            if (month.includes('_')) {
                month = month.replace('_', '-');
            }
            return moment(month).format('M') + '월';
        },
        //월변환 2
        signStatus() {
            if (this.sign == true && this.resign == true) {
                this.checkStaff = []; //초기화처리
                return 'T';
            } else if (this.sign == true) {
                this.checkStaff = []; //초기화처리
                return 'I';
            } else if (this.resign == true) {
                this.checkStaff = []; //초기화처리
                return 'O';
            }
        },
        //날짜변환
        formatMonth(date) {
            return moment(date).format('M') + '월';
        },

        // 기간별 보고서 엑셀 다운로드 기능
        execlDownload() {
            const wb = XLSX.utils.book_new();
            const monthReportDataWS = this.getReportDataWS();
            const staffStatListWS = this.getStaffStatListWS();

            XLSX.utils.book_append_sheet(wb, monthReportDataWS, '기간별보고서');
            XLSX.utils.book_append_sheet(wb, staffStatListWS, '직원');
            XLSX.writeFile(wb, '기간별보고서.xlsx');
        },

        // 기간별 보고서의 세부 내용 Work Sheet를 생성하는 함수
        getReportDataWS() {
            let excelDownloadArray = [];

            this.writeConsultinExcel(excelDownloadArray);
            excelDownloadArray.push([]);

            this.writePriceinExcel(excelDownloadArray);
            excelDownloadArray.push([]);

            this.writeContractTypeinExcel(excelDownloadArray);
            excelDownloadArray.push([]);

            this.writePayTypeinExcel(excelDownloadArray);
            excelDownloadArray.push([]);

            this.writeTicketTypeinExcel(excelDownloadArray);
            excelDownloadArray.push([]);

            let dataWS = XLSX.utils.aoa_to_sheet(excelDownloadArray);

            // cell width 설정
            let wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            return dataWS;
        },

        // 매출 내용을 엑셀에 저장하는 함수
        writeConsultinExcel(excelDownloadArray) {
            excelDownloadArray.push(['상담']);
            excelDownloadArray.push(['', '전화', '방문', '기타', '총 상담수']);
            const props = ['tel', 'visit', 'etc', 'total'];
            this.insertExcelDownloadArray(excelDownloadArray, props, this.consult);
        },

        // 상담 내용을 엑셀에 저장하기 위해 배열의 형태로 정리하는 함수
        writePriceinExcel(excelDownloadArray) {
            excelDownloadArray.push(['매출']);
            excelDownloadArray.push(['', '이용권 수입', '일반수입', '환불', '매출합계']);
            const props1 = ['ticketIncome', 'income', 'refund', 'saleTotal'];
            this.insertExcelDownloadArray(excelDownloadArray, props1, this.price);

            excelDownloadArray.push(['', '고정지출', '변동지출', '급여', '지출합계', '영업이익']);
            const props2 = ['fix', 'vari', 'salary', 'expenseTotal', 'sale'];
            this.insertExcelDownloadArray(excelDownloadArray, props2, this.price);

            excelDownloadArray.push(['', '이용권 소진금액', '이용권 잔여금액']);
            const props3 = ['used', 'remain'];
            this.insertExcelDownloadArray(excelDownloadArray, props3, this.price);
        },

        // 신규 / 재등록 현황 내용을 엑셀에 작성하는 부분
        writeContractTypeinExcel(excelDownloadArray) {
            excelDownloadArray.push(['신규 / 재등록 현황']);
            excelDownloadArray.push(['', '신규건수', '신규매출', '재등록건수', '재등록매출']);
            const props = ['new', 'newSale', 're', 'reSale'];
            this.insertExcelDownloadArray(excelDownloadArray, props, this.contractType);
        },

        // 결제수단별 상품매출 내용을 엑셀에 작성하는 부분
        writePayTypeinExcel(excelDownloadArray) {
            excelDownloadArray.push(['결제수단별 상품매출(이용권 수입 + 일반 수입)']);
            excelDownloadArray.push(['', '핏페이', '카드', '현금', '계좌', '기타', '합계', '마일리지 사용']);
            const props = ['fitpay', 'card', 'cash', 'bank', 'etc', 'total', 'mileage'];
            this.insertExcelDownloadArray(excelDownloadArray, props, this.payType);
        },

        // 이용권 구분별 매출현황 내용을 엑셀에 작성하는 부분
        writeTicketTypeinExcel(excelDownloadArray) {
            excelDownloadArray.push(['이용권 구분별 매출현황']);
            excelDownloadArray.push(['', '개인', '듀엣', '오티', '그룹', '쿠폰', '회원권', '운동복', '패키지', '합계']);
            const props = ['person', 'duet', 'ot', 'group', 'coupon', 'ticket', 'sport', 'pakage', 'total'];
            this.insertExcelDownloadArray(excelDownloadArray, props, this.ticketType);
        },

        // excelDownloadArray에 원소를 삽입할 때 하는 공통의 기능을 담당하는 함수
        insertExcelDownloadArray(excelDownloadArray, props, list) {
            for (let item of list) {
                let temp = [];
                temp.push(this.convertMonth(item.month));
                for (let prop of props) {
                    temp.push(numberFormat(Number(item[prop])));
                }
                excelDownloadArray.push(temp);
            }
        },

        // 직원 Work Sheet 생성하는 함수
        getStaffStatListWS() {
            let excelDownloadArray = [];
            let wscols = [];

            this.staff.flat().forEach((m) => {
                let temp = {};
                temp['직원명'] = m.csbb_center_staff_nm;
                temp['월'] = this.formatMonth(m.csbb_bill_year_month);
                temp['총 매출'] = numberFormat(Number(m.csbb_total_sale_price));
                temp['신규매출'] = numberFormat(Number(m.csbb_sale_new_price));
                temp['재등록 매출'] = numberFormat(Number(m.csbb_sale_renew_price));
                temp['소진금액'] = numberFormat(Number(m.csbb_tick_use_price));
                temp['잔여금액'] = numberFormat(Number(m.csbb_real_sale_price));
                temp['유효건수'] = numberFormat(Number(m.csbb_less_valid_cnt));
                temp['종료건수'] = numberFormat(Number(m.csbb_less_finish_cnt));
                temp['신규건수'] = numberFormat(Number(m.csbb_sale_new_cnt));
                temp['재등록 건수'] = numberFormat(Number(m.csbb_sale_renew_cnt));
                temp['총 수업 수'] = numberFormat(Number(m.csbb_less_total_cnt));
                temp['차인 지급액'] = numberFormat(Number(m.csbb_real_sale_price));
                excelDownloadArray.push(temp);
                wscols.push({ wch: 12 });
            });

            let dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            dataWS['!cols'] = wscols;

            return dataWS;
        },
        //환불현황
        async onReturnStat() {
            let thisMonth = await this.getReturnStat(this.startDate, this.endDate); //당월
            let prevMonth = await this.getReturnStat(
                moment(this.startDate).subtract(1, 'month').format('YYYYMMDD'),
                moment(this.endDate).subtract(1, 'month').format('YYYYMMDD')
            ); //전월
            let twoMonthAgo = await this.getReturnStat(
                moment(this.startDate).subtract(2, 'month').format('YYYYMMDD'),
                moment(this.endDate).subtract(2, 'month').format('YYYYMMDD')
            ); //전전월

            let period = moment(this.endDate).diff(moment(this.startDate), 'months');
            switch (period) {
                case 0:
                    this.refundStatus = []; //초기화
                    thisMonth.data[0].cc_date = this.startDate; //월 입력
                    this.refundStatus.push(thisMonth.data[0]);
                    break;
                case 1:
                    this.refundStatus = []; //초기화
                    thisMonth.data[0].cc_date = this.endDate; //월 입력
                    prevMonth.data[0].cc_date = this.startDate; //월 입력
                    this.refundStatus.push(prevMonth.data[0]);
                    this.refundStatus.push(thisMonth.data[0]);
                    break;
                case 2:
                    this.refundStatus = []; //초기화
                    thisMonth.data[0].cc_date = this.endDate; //월 입력
                    prevMonth.data[0].cc_date = moment(this.endDate).subtract(1, 'month').format('YYYYMM'); //월 입력
                    twoMonthAgo.data[0].cc_date = this.startDate; //월 입력
                    this.refundStatus.push(twoMonthAgo.data[0]);
                    this.refundStatus.push(prevMonth.data[0]);
                    this.refundStatus.push(thisMonth.data[0]);
                    break;
            }
            console.log(period);
        },
        getReturnStat(startDate, endDate) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/return-stats`, {
                params: {
                    startDate: moment(startDate).startOf('month').format('YYYYMMDD'),
                    endDate: moment(endDate).endOf('month').format('YYYYMMDD'),
                },
            });
        },
    },
};
</script>
<style lang="scss"></style>
